module.exports = __webpack_public_path__ + "static/media/sunset@2x.7484090d.png";